module.exports = __webpack_public_path__ + "static/media/30_plantilla_cuadrada_combo_simple_cp_gaseosas_pet_237_sp.95320ed8.png";